import { render, staticRenderFns } from "./AppNavigationBarConfig.vue?vue&type=template&id=7bcdfcaf"
import script from "./AppNavigationBarConfig.vue?vue&type=script&lang=js"
export * from "./AppNavigationBarConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports